import {Component, Injector, OnDestroy} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import { ActivatedRoute } from '@angular/router';
import {LabsApiService} from '@api/labs.api.service';
import {Anchor} from '@layoutComponents/page-inside-navigation/anchor.interface';
import {debounceTime} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {LaboratoryDocumentsProvider} from '@providers/laboratory-documents/laboratory-documents.provider';
import {AuthService} from '@services/auth.service';
import {UserNamespace} from '@namespaces/user.namespace';

@Component({
    providers: [
    ],
    selector: 'laboratory-form',
    templateUrl: './laboratory-form.component.html',
    styleUrls: ['./laboratory-form.component.scss']
})
export class LaboratoryFormComponent extends FrontendFormComponent implements OnDestroy {

    public afterSaveMessage = 'Данные лаборатории успешно сохранены';

    public anchors: Anchor[] = [
        {title: 'Данные лаборатории', targetId: 'common', error: false},
        {title: 'Ответственные лица', targetId: 'responsible', error: false},
    ];

    public canViewDocuments = false;
    public canAddDocuments = false;

    private subs: Subscription[] = [];

    constructor(
        injector: Injector,
        private route: ActivatedRoute,
        public formService: LabsApiService,
        public laboratoryDocumentsProvider: LaboratoryDocumentsProvider,
        private authService: AuthService,
    ) {
        super(injector);
    }

    init() {
        this.form = this._fb.group({
            id: [],
            title: [],
            short_title: [],
            real_address_city_id: [],
            real_address_city: [],
            real_address_index: [],
            real_address: [],
            leader_id: [],
            leader_job: [],
            rooms: [],
            square: [],
            // responsible: this._fb.group({
            //     quality: [],
            //     support: [],
            //     archive: [],
            //     ntd: [],
            //     iii: [],
            //     rk: [],
            // })
        });

        const {formValues} = this.route.snapshot.data;

        if (formValues) {
            this.setFormValues(formValues, this.form);
        }

        this.subs.push(
            this.form.statusChanges.pipe(
                debounceTime(100)
            ).subscribe(() => {
                this.updateAnchorsValidity();
            })
        );

        this.canViewDocuments = this.authService.hasPermissions([UserNamespace.Permission.structureUnitDocumentList]);
        this.canAddDocuments = this.authService.hasPermissions([UserNamespace.Permission.structureUnitDocumentCreate]);

        if (this.canViewDocuments) {
            this.anchors.push(
                {title: 'Документы лаборатории', targetId: 'documents', error: false}
            );
        }
    }

    setAnchorErrorStatus(targetId: string, valid: boolean) {
        if (!targetId) {
            return;
        }

        const anchor = this.anchors.find(a => a.targetId === targetId);

        if (!anchor) {
            return;
        }

        anchor.error = !valid;

        this.anchors = [...this.anchors];
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }

    private updateAnchorsValidity() {
        const common = [
            'title',
            'short_title',
            'real_address_city_id',
            'real_address_city',
            'real_address_index',
            'real_address',
            'leader_id',
            'leader_job',
            'rooms',
            'square',
        ];

        this.setAnchorErrorStatus('common', this.getValidStatusForFields(common));
    }

    private getValidStatusForFields(fields: string[]) {
        return fields.every(field => {
            return this.form.get(field).disabled || this.form.get(field).valid;
        });
    }
}

